// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";

export async function trackStep2VideoProgress(props: { actionableId: bigint; progress: number }): Promise<ApiResult> {
  let path = "/gaapi/actionables/{actionableId}/step2-video-progress";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.progress].flat().forEach((value) => {
    urlSearchParams.append(
      "progress",
      ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.toString() !== "") {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}
